"use client";

import React, { useMemo } from "react";
// eslint-disable-next-line @faire/no-theme-provider-from-styled-components
import {
  DefaultTheme as StyledComponentsDefaultTheme,
  ThemeProvider as StyledComponentsThemeProvider,
} from "styled-components";

import { DefaultTheme } from "./DefaultTheme";
import { ITheme } from "./Theme";

export const themeNames = ["Faire"] as const;

const themes: { [key in ThemeName]: ITheme } = {
  Faire: DefaultTheme,
} as const;

type ThemeName = (typeof themeNames)[number];

export const ThemeProvider: React.FC<{
  children?: React.ReactNode;
  theme: ThemeName | StyledComponentsDefaultTheme;
}> = ({ theme, children }) => {
  return useMemo(() => {
    return (
      <StyledComponentsThemeProvider theme={resolveTheme(theme)}>
        {children}
      </StyledComponentsThemeProvider>
    );
  }, [children, theme]);
};

const resolveTheme = (
  theme: ThemeName | StyledComponentsDefaultTheme
): ITheme => {
  let resolvedTheme: ITheme;
  if (typeof theme === "string") {
    resolvedTheme = getTheme(theme as ThemeName);
  } else {
    resolvedTheme = theme;
  }
  return resolvedTheme;
};

export const getTheme = (themeName: ThemeName): ITheme => {
  return themes[themeName] ?? DefaultTheme;
};
